import { render } from "./Edit.vue?vue&type=template&id=39ef0575&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=39ef0575&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ef0575"]])

export default __exports__